import { createBrowserRouter } from "react-router-dom";
import Login from "../features/login/Login";
import Layout from "../features/layout/Layout";
import { DefaultUserPage } from "../features/user";
import { CreationProductPage, IndexProductPage } from "../features/produk";
import { CreationSupplierPage, IndexSupplierPage } from "../features/supplier";
import { CreationPageSubDealer, IndexPageDealer } from "../features/dealer";
import {
  CreationInvoicePage,
  CreationPaymentMethodPage,
  CreationPembelianPage,
  CreationReturPage,
  IndexInvoicePage,
  IndexPaymentMethodPage,
  IndexPembelianPage,
  ReturPage,
} from "../features/invoice";
import { CreationBrandPage, IndexPageBrand } from "../features/brand";
import { CreationKategoriPage, IndexKategoriPage } from "../features/kategori";
import PrivateRoute from "./PrivateRoute";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        path: "/",
        element: <DefaultUserPage />,
      },
      {
        path: "/user",
        element: <DefaultUserPage />,
      },
      {
        path: "/brand",
        element: <IndexPageBrand />,
      },
      {
        path: "/brand/creation/:idBrand?",
        element: <CreationBrandPage />,
      },
      {
        path: "/kategori",
        element: <IndexKategoriPage />,
      },
      {
        path: "/kategori/creation/:idCategory?",
        element: <CreationKategoriPage />,
      },
      {
        path: "/produk",
        element: <IndexProductPage />,
      },
      {
        path: "/produk/creation/:idProduct?",
        element: <CreationProductPage />,
      },
      {
        path: "/invoice",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <IndexInvoicePage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/creation/:idInvoice?",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <CreationInvoicePage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/payment-method",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <IndexPaymentMethodPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/payment-method/creation/:idPaymentMethod?",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <CreationPaymentMethodPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/pembelian",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <IndexPembelianPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/pembelian/creation/:idPurchaseInvoice?",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <CreationPembelianPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/retur",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <ReturPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/invoice/retur/:idRetur",
        element: (
          <PrivateRoute preventAccessTo={["SPM"]}>
            <CreationReturPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/supplier",
        element: <IndexSupplierPage />,
      },
      {
        path: "/supplier/creation/:idSupplier?",
        element: <CreationSupplierPage />,
      },
      {
        path: "/dealer",
        element: <IndexPageDealer />,
      },
      {
        path: "/dealer/creation/:idSubDealer?",
        element: <CreationPageSubDealer />,
      },
    ],
  },
]);

export default router;
